/*
 * GoalResultDetailsItem.jsx 21.08.18
 *
 * (c) 2018 ergovia GmbH
 */

import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import History from './History';
import format from 'date-fns/format';

const dateFormat = 'DD.MM.YYYY';

const styles = theme => ({
    goalFrame: {
        overflowY: 'auto'
    },

    goalDetails: {
        width: 'auto',
        margin: '0.8rem 24px 0.8rem 24px',
        borderRadius: 4,

        backgroundColor: '#ffffff',
        color: '#3F3F4E'
    },
    goalStep: {
        display: 'grid',
        minHeight: 300,
        gridTemplateColumns: 'auto 200px',
        gridTemplateAreas: '"stepText history" "stepProfessionText history" "stepDate history"'
    },
    stepText: {
        gridArea: 'stepText',
        paddingTop: '0.5rem',
        minHeight: 120,
        fontWeight: 400,
        color: theme.palette.text.secondary
    },
    stepDate: {
        gridArea: 'stepDate',
        padding: '1rem 5rem 1rem 2rem',
        fontWeight: 400,
        color: theme.palette.text.secondary
    },
    stepAufgabeBody: {
        padding: '1rem 5rem 1rem 2rem'
    },
    stepProfessionTitle: {
        fontWeight: 'bold',
        fontSize: 16,
        color: theme.palette.text.secondary
    },
    stepProfessionText: {
        color: theme.palette.text.secondary
    },
    goalCreatedByLabel: {
        gridArea: 'goalCreatedByLabel',
        padding: '0 1rem',
        fontSize: '0.8em',
        color: theme.palette.text.secondary
    },
    heading: {
        margin: '60px 0 20px 20px'
    },
    stepProfession: {
        gridArea: 'stepProfessionText',
        marginBottom: 5,
        minHeight: 120,
        fontWeight: 400,
        color: theme.palette.text.secondary
    }

});

/**
 * Komponente zur Darstellung von Schritten zur Zielerreichung
 */
class GoalStepDetailsItem extends React.Component {

    /**
     * Registriert einen Listener "focus": Wenn das Browser-Fenster in den Vordergrund geholt wird,
     * dann sollen die Daten der Schritte eines Ziels aktualisiert werden.
     */
    constructor() {
        super();
        this.focusListener = this.refetchGoalSteps.bind(this);
        window.addEventListener('focus', this.focusListener);
    }

    /**
     * Deregistriert den Listener auf das Browser-Fenster, wenn die Komponente abgeräumt wird.
     */
    componentWillUnmount() {
        window.removeEventListener('focus', this.focusListener);
    }

    /**
     * Löst einen Apollo-Refetch über die Schrittdaten eines Ziels aus.
     */
    refetchGoalSteps() {
        this.props.refetchGoalSteps();
    }

    render() {

        const {classes, goalSteps} = this.props;

        const Heading = () => {
            if (goalSteps.length) {
                return <Typography variant="subheading" color="primary" className={classes.heading} style={{textTransform: 'uppercase'}} >Schritte zur Zielerreichung</Typography>;
            }
            return null;
        };

        const Aufgabe = props => {
            if (props.text) {
                return (
                    <div className={props.class}>
                        <Typography className={classes.stepProfessionTitle}>{props.title}</Typography>
                        <Typography className={classes.stepProfessionText} >{props.text}</Typography>
                    </div>);
            }
            return null;

        };

        return (
            <div>
                <Heading />
                {goalSteps
                    .map(gs => <Paper key={gs.id} className={classes.goalDetails} elevation={2}>

                        <div className={classes.goalStep}>
                            <div className={classes.stepText}>
                                <Aufgabe class={classes.stepAufgabeBody} title={'Aufgaben Teilnehmer'} text={gs.aufgabeTeilnehmer}/>
                                <Aufgabe class={classes.stepAufgabeBody} title={'Aufgaben Träger'} text={gs.aufgabeTraeger}/>
                            </div>

                            <div className={classes.stepProfession}>
                                {gs.professionen.map(pr => <Aufgabe key={pr.profession} class={classes.stepAufgabeBody} title={`Aufgaben ${pr.profession}`} text={pr.aufgabe}/>)}
                            </div>

                            {gs.datum && <Typography className={classes.stepDate} >{format(gs.datum, dateFormat)}</Typography>}
                            <History history={gs} />
                        </div>
                    </Paper>)}
            </div>
        );
    }

}

export default withStyles(styles)(GoalStepDetailsItem);



// WEBPACK FOOTER //
// ./src/de/ergovia/components/detail/GoalStepsDetailsItem.jsx